import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, NumberValueAccessor } from '@angular/forms';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject, Subscription } from 'rxjs';
import { FilterProjectDto } from 'src/app/web/interfaces/project/list/filterProjectDto';
import { FilterProjectInfoDto } from 'src/app/web/interfaces/project/list/filterProjectInfoDto';
import { FilterProjectInfoFrenteDto } from 'src/app/web/interfaces/project/list/filterProjectInfoFrenteDto';
import { ViewProjectPayDto } from 'src/app/web/interfaces/project/list/viewProjectPayDto';
import { FilterProjectStadoDto } from 'src/app/web/interfaces/project/list/filterProjectStadoDto';
import { ViewProject } from 'src/app/web/interfaces/project/list/viewProjectDto';
import { DropdownSettingsStado, FormatDataTableGlobal } from 'src/app/web/util/formatDataTable';
import Swal from 'sweetalert2/dist/sweetalert2.js'; 
import { ApiServiceProject } from '../../../apis/ApiServiceProject';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorService } from 'src/app/shared/services/errors.service';

export class listPay {

  id:number;
  title:string;
  scheduled_date:string;
  rescheduled_date:string;
  real_date:string;
  status:string;
  anexo:number;
  name:string;
  pay_amount:string;
  amount_percent:string;
  money:string;
}

@Component({
  selector: 'app-list-pay-project',
  templateUrl: './list-pay-project.component.html',
  styleUrls: ['./list-pay-project.component.scss']
})
export class ListPayProjectComponent implements AfterViewInit, OnDestroy, OnInit {

  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  dtTrigger = new Subject();
  dtOptions: DataTables.Settings = {};
  idProject: number;
  name: string;
  private apiService: ApiServiceProject;
  idSubscription: Subscription;
  searchForm: FormGroup;
  ListPay: listPay[] = []
  listViewProjectDto: ViewProject[] = []
  listViewProjectDtoBack: ViewProject[] = []
  filterProjectInfoDto: FilterProjectInfoDto = {} as FilterProjectInfoDto
  filterProjectInfoFrenteDto: FilterProjectInfoFrenteDto[] = []
  filterProjectDto: FilterProjectDto = {} as FilterProjectDto;
  selectedItems = [];
  dropdownSettings = {};
  opcionClient = 0
  opcionFrete = 0
  opcionSeleccionado = "todo"
  permiso: number[] = []

  constructor(private http: HttpClient,
    private spinner: NgxSpinnerService,
    config: NgbDropdownConfig,
    private fb: FormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private errorService:ErrorService
  ) 
    {
      config.placement = 'bottom';
      this.idSubscription = this.activatedRoute.params.subscribe(params => {
        this.name = params['name'];
        return this.idProject = params['id_project'];
        
      })
    }

  ngOnInit(): void {

   
    
    this.dtOptions = FormatDataTableGlobal();
    this.dropdownSettings = DropdownSettingsStado();
    this.apiService =  new ApiServiceProject(this.http);

    this.searchForm = this.fb.group({
      stado: [],
      client: {},
      frete: {},
      type: {},
      item: [],
    });

    this.searchForm.get('client').setValue(0);
    this.searchForm.get('frete').setValue(0);
    this.searchForm.get('type').setValue(0);

    let listFilterTaasStadoDto: FilterProjectStadoDto[] = []

    let filterTaasStadoDto: FilterProjectStadoDto = {
      active: 1,
      closed: 0,
      stop: 0
    };

    listFilterTaasStadoDto.push(filterTaasStadoDto)

    this.filterProjectDto.client_id = 0
    this.filterProjectDto.frentes_id = 0
    this.filterProjectDto.itemSelect = [1,2,3,4,5,9,16,17]
    this.filterProjectDto.type_id = 0
    this.filterProjectDto.stado = listFilterTaasStadoDto


    this.spinner.show();

    // this.permiso = this.errorService.getPermisses();
    // if (this.permiso.find(element => element == 4)) {
    // }  else {
    //   this.errorService.error2(403)
    //   this.spinner.hide();
    // }

    this.apiService.getService('list-project-play?id_project=' + this.idProject).subscribe({
      next: (rs:any) => {
        

        if (rs.code == null) {
          // si la respuesta no tiene error pero no tiene data se manda un mensaje de error y se retorna al home
          if (rs == '' || rs == null) {
            this.spinner.hide();
            Swal.fire({
              title: 'No se encontraron registros',
              text: '',
              icon: 'info',
              confirmButtonText: 'Aceptar',
              heightAuto: false
            }).then((res) => {
              if (res.isConfirmed || res.isDismissed) {
                this.router.navigate(['home']);
              }
            });
          }
          localStorage.setItem("info-mtn", JSON.stringify(rs));
          this.ListPay = rs.listProjectPlay;
          this.spinner.hide();
          this.rerender();
        } else {
          
          this.spinner.hide();
          Swal.fire({
          title:  rs.error,
          text: '',
          icon: 'error',
          heightAuto: false
          });
        }
      },
      error: (error) => {
        this.errorService.error(error);
      },
    });

  }

  get form() {
    return this.searchForm.controls;
  }

  onItemSelect(item: any) {

  }

  actionSelectClient(){
    this.filterProjectInfoFrenteDto = this.form['client'].value.listFrente;

  }

  btnSearch() {
    let idFrente = 0;
    let idClient = 0;
    let idType = 0;

    let activeEnd = 0;
    let closedEnd = 0;
    let stopEnd = 0;


    if(this.form['client'].value.id != null){
      idClient = this.form['client'].value.id ;

      if(this.form['frete'].value.id != null){
        idFrente = this.form['frete'].value.id ;
      }
    }

    if(this.form['type'].value.id != null){
      idType = this.form['type'].value.id ;
    }
    if(this.form['stado'].value[0] != null){
      let activos =  this.form['stado'].value.filter( n =>  n.name == "Activos")
      let pausados =  this.form['stado'].value.filter( n =>  n.name == "Pausados")
      let cerrados =  this.form['stado'].value.filter( n =>  n.name == "Cerrados")

      if(activos[0] != null){
        activeEnd = 1
      }
      if(pausados[0] != null){
        stopEnd = 1
      }
      
      if(cerrados[0] != null){
        closedEnd = 1
      }
    }else{
      Swal.fire({title:"Debe selecciona una de estado" ,text: '',icon: 'error',heightAuto: false});
      return;
    }

    let item = []
    for(let info of this.form['item'].value){
      item.push(info.id)
    }

    if(item.length == 0){
      Swal.fire({title:"Debe selecciona un Item" ,text: '',icon: 'error',heightAuto: false});
      return;
    }


    let listFilterTaasStadoDto: FilterProjectStadoDto[] = []

    let filterTaasStadoDto: FilterProjectStadoDto = {
      active: activeEnd,
      closed: closedEnd,
      stop: stopEnd
    };

    listFilterTaasStadoDto.push(filterTaasStadoDto)

    this.filterProjectDto.client_id = idClient
    this.filterProjectDto.frentes_id = idFrente
    this.filterProjectDto.itemSelect = item
    this.filterProjectDto.type_id = idType
    this.filterProjectDto.stado = listFilterTaasStadoDto

    this.searchInfo(this.filterProjectDto)
  }

  searchInfo(info:FilterProjectDto){

    this.spinner.show();

    this.apiService.postService("list-project",info).subscribe({
      next: (rs:any) => {

        if(rs.code == null){
          this.listViewProjectDto = [];
          this.listViewProjectDtoBack = [];
          this.opcionSeleccionado = "todo"
          this.listViewProjectDto = rs
          this.listViewProjectDtoBack = rs;

          this.spinner.hide()
          this.rerender()
        }else{
          this.listViewProjectDto = [];
          this.listViewProjectDtoBack = [];
          this.rerender()
          this.spinner.hide()
          Swal.fire({title:rs.error,text: '',icon: 'error',heightAuto: false});
        }
      
      },
      error: (error) => {
        this.errorService.error(error);
      }
    });
  }

 
  
  actionSelectFiter(opcionSeleccionado:any){
    this.listViewProjectDto = this.listViewProjectDtoBack 

    if(opcionSeleccionado.target.value == "todo"){
      this.rerender()
      return;
    }

    this.listViewProjectDto = this.listViewProjectDto.filter( n =>  n.payment.colorStatus == opcionSeleccionado.target.value)

    if(this.listViewProjectDto[0] == null){
      this.listViewProjectDto = []
    }
    this.rerender()

  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  projectDetails(id: number) {
    this.spinner.show();
    this.router.navigate([`/pdg/project/list/view/${id}`]);
  }

  stageAnularPay(id:any, monto){

    let text = '¿Desea Anular el pago?'
    if(this.valideNegative(monto)){
      text = '¿Desea Anular el descuento?'
    }

    Swal.fire({
              title: 'Anular',
              text: text,
              icon: 'warning',
              showCancelButton:true,
              confirmButtonText: 'Aceptar',
              cancelButtonText:"No, cancelar",
              heightAuto: false
            }).then((res) => {
              if (res.isConfirmed) {
                this.spinner.show()
                this.apiService.putService('anular-project-play?id=' + id).subscribe({
                  next: (rs: any) => {
                    if (rs) {
                      this.spinner.hide();
                      Swal.fire({title:'Exito!',text:'Se ha anulado con exito!',icon: 'success',heightAuto: false}).then(()=>{location.reload()})
                      
                    } else {
                        this.spinner.hide();
                        Swal.fire({
                        title:  rs.error,
                        text: '',
                        icon: 'error',
                        heightAuto: false
                        }); } },
                  error: (error) => {
                    this.errorService.error(error);
                  },});
              }
              else if ( res.dismiss === Swal.DismissReason.cancel){
                Swal.fire({
                  title: 'Cancelado',
                  text: 'Operación cancelada.',
                  icon: 'error',
                  heightAuto: false
                  })

              }
            });


  }

  stageDeletePay(id:any, monto){
    let text = '¿Desea Anular el pago?'
    if(this.valideNegative(monto)){
      text = '¿Desea Anular el descuento?'
    }
    Swal.fire({
              title: 'Eliminar',
              text: text,
              icon: 'error',
              showCancelButton:true,
              confirmButtonText: 'Aceptar',
              cancelButtonText:"No, cancelar",
              heightAuto: false
            }).then((res) => {
              if (res.isConfirmed) {
                this.spinner.show()
                this.apiService.deleteService('delete-project-play?id=' + id).subscribe({
                  next: (rs: any) => {
                    if (rs) {
                      this.spinner.hide();
                      Swal.fire({title:'Exito!',text: 'Se ha eliminado con exito!',icon: 'success',heightAuto: false}).then(()=>{location.reload()})
                      
                    } else {
                        this.spinner.hide();
                        Swal.fire({
                        title:  rs.error,
                        text: '',
                        icon: 'error',
                        heightAuto: false
                        }); } },
                  error: (error) => {
                    this.errorService.error(error);
                  },});
              }
              else if ( res.dismiss === Swal.DismissReason.cancel){
                Swal.fire({
                  title: 'Cancelado',
                  text: 'Operación cancelada.',
                  icon: 'error',
                  heightAuto: false
                  })

              }
            });


  }

  stageCancelPay(id:any, monto){

    let text = '¿Desea cancelar el pago?'
    if(this.valideNegative(monto)){
      text = '¿Desea cancelar el descuento?'
    }
    Swal.fire({
              title: 'Cancelar Pago',
              text: text,
              icon: 'warning',
              showCancelButton:true,
              confirmButtonText: 'Aceptar',
              cancelButtonText:"No, cancelar",
              heightAuto: false
            }).then((res) => {
              if (res.isConfirmed) {
                this.spinner.show()
                this.apiService.putService('cancel-project-play?id=' + id).subscribe({
                  next: (rs: any) => {
                    if (rs) {
                      this.spinner.hide();
                      Swal.fire({title:'Exito!',text:'Se ha cancelado con exito!',icon: 'success',heightAuto: false}).then(()=>{location.reload()})
                      
                    } else {
                        this.spinner.hide();
                        Swal.fire({
                        title:  rs.error,
                        text: '',
                        icon: 'error',
                        heightAuto: false
                        }); } },
                  error: (error) => {
                    this.errorService.error(error);
                  },});
              }
              else if ( res.dismiss === Swal.DismissReason.cancel){
                Swal.fire({
                  title: 'Cancelado',
                  text: 'Operación cancelada.',
                  icon: 'error',
                  heightAuto: false
                })

              }
            });


  }

  Pagos(enable: number, id: number, name: string) {

    if (enable == 1) {
      this.spinner.show();
    this.router.navigate([`/pdg/project/pay/list/${id}/${name}`]);
    }
  }

  valideNegative(monto){
    if(monto.toString().includes("-")){
      return true
    }
    return false
  }

}
